let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9pxSK")).then(() => parcelRequire('k5jfD'));